const Unauthorized: React.FC = () => {
  return <h1>Unauthorized access...</h1>;
};

export default Unauthorized;
